/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SuppressTimeRegOutsideProjectPeriodWarningInput = {
    projectId: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type suppressTimeRegOutsideProjectPeriodWarningMutationVariables = {
    input: SuppressTimeRegOutsideProjectPeriodWarningInput;
};
export type suppressTimeRegOutsideProjectPeriodWarningMutationResponse = {
    readonly suppressTimeRegOutsideProjectPeriodWarning: {
        readonly clientMutationId: string | null;
    } | null;
};
export type suppressTimeRegOutsideProjectPeriodWarningMutation = {
    readonly response: suppressTimeRegOutsideProjectPeriodWarningMutationResponse;
    readonly variables: suppressTimeRegOutsideProjectPeriodWarningMutationVariables;
};



/*
mutation suppressTimeRegOutsideProjectPeriodWarningMutation(
  $input: SuppressTimeRegOutsideProjectPeriodWarningInput!
) {
  suppressTimeRegOutsideProjectPeriodWarning(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SuppressTimeRegOutsideProjectPeriodWarningInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SuppressTimeRegOutsideProjectPeriodWarningPayload",
    "kind": "LinkedField",
    "name": "suppressTimeRegOutsideProjectPeriodWarning",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "suppressTimeRegOutsideProjectPeriodWarningMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "suppressTimeRegOutsideProjectPeriodWarningMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "suppressTimeRegOutsideProjectPeriodWarningMutation",
    "operationKind": "mutation",
    "text": "mutation suppressTimeRegOutsideProjectPeriodWarningMutation(\n  $input: SuppressTimeRegOutsideProjectPeriodWarningInput!\n) {\n  suppressTimeRegOutsideProjectPeriodWarning(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '1bdb276993b1a24d6c34f5927ea00c16';
export default node;
